<template>
<div>
    <Nav />
      <div class="pageWD shadowBox mT20 minHeight">
        <div class="pheader flex flex-sb think">
         <img src="../../assets/images/qiyezhiku.png" style="width:145px; height:58px" />  
         <div  class="flex flex-sb" style="position:relative;top:-10px">  
            <el-input type="text" v-model="courseName" placeholder="关键字搜索" style="width:400px"></el-input>
            <el-button type="primary" @click="goSearch"  style="width:100px;margin:0 20px">确定</el-button>
            <el-button style="width:100px;"  @click="goAll" >全部</el-button>
        </div>
         <el-dropdown  @command="handleCommand">
          <span class="el-dropdown-link">
            {{currentItem}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" style="padding:0">
            <div class="think-item">
              <el-dropdown-item  style="margin-bottom:1px" class="c9 f18" v-for="(item,index) in classiesType" :key="index" :command="composeValue(item.cyId,item.cyName,index)" :class="{'selected':status==index}">{{item.cyName}}</el-dropdown-item>  
            </div>  
          </el-dropdown-menu>
        </el-dropdown>    
        </div>
        <div>
          <ul class="plist" v-if="classies.length!=0">
             <li v-for="(item,index) in classies" :key="index" @click="toPlay(item.cmId)">
                 <ClassItem  :index="index" :item="item"/>
             </li>    
              <div v-if="lens!='0'">
               <li v-for="(item,index) in 4-lens" >
                  <EmptyItem  :index="index" />     
               </li>
             </div>             
          </ul>
           <div v-else>
            <Empty />
          </div>  
        </div>
      </div>
     <div style="height:20px"></div>
</div>
</template>
<script>
  import Cookies from "js-cookie";
  import Nav from "@/components/Nav.vue";
  import ClassItem from "@/components/ClassItem.vue";
  import EmptyItem from "@/components/EmptyItem.vue";
  import Empty from "@/components/Empty.vue";
  import { getCourseList , getCourseType } from '@/api/api'
  export default {
    components: {Nav,ClassItem ,Empty,EmptyItem},
    data() {
        return { 
            courseName:'',
            status: '0',
            classies:[],
            lens:'0',
            classiesType:[],
            currentItem:'全部课程'
        }
    },
    watch:{
      classies(){
        if(this.classies.length){       
          var l = parseInt(this.classies.length/4)
          this.lens =this.classies.length- l*4  
        }
       }
    },
    created() {
        this.getClassList('')//获取课程列表
        this.getCourseType()//获取课程分类
    },
    methods: { 
      goSearch(){
           this.currentItem = '全部课程'
           this.courseType = ''
           this.getClassList('')
      },
       goAll(){
           this.courseName = ''
           this.currentItem = '全部课程'
           this.courseType = ''
           this.getClassList('')
      },
      toPlay(cmId){
         this.$router.push({path:'home/play',query:{courseId:cmId}});
      },
      handleCommand(e){
        console.log(e)
         this.currentItem = e.name
         this.status = e.index
         this.getClassList(e.id)//获取课程列表
      },
      composeValue(id,name,index) {
        return {
          'id': id,
          'name':name,
          'index':index
        }
      },
     
      getClassList(id) {
          var that = this;
          let data = {
              memberId: Cookies.get('qslmemberId'),
              COID: Cookies.get('qslCOID'),
              pageIndex: 1,
              pageSize: 100,
              courseType: id,
              courseName:this.courseName
          };
          getCourseList(data)
              .then(res => {
                  console.log( res.body.result)
                  that.classies = res.body.result
              })
              .catch(err => {});
      },
        getCourseType() {
          var that = this;
          let data = {
              memberId: Cookies.get('qslmemberId'),
              COID: Cookies.get('qslCOID')              
          };
          getCourseType(data)
              .then(res => {                 
                  that.classiesType = res.body.result
                   var all={
                    cyId:'',
                    cyName:'全部课程'
                  }
                  that.classiesType.unshift(all)
                  
                  console.log(that.classiesType)
              })
              .catch(err => {});
      }
    }
  }
</script>

<style scoped>
>>> .el-dropdown-menu{
  padding:0
}
.think .el-dropdown
{
width: 160px;
height: 48px;
background: #f0f0f0;
border-radius: 8px;
position:relative;
top:-10px;
text-align:center;
line-height:48px;
}
.think .el-dropdown-link{
  display:block;
  font-size:18px;
  color:#999
}
.think .el-dropdown-menu{
  width:160px;
  padding:0;
  top:-20px
}
.think-item {
  width:160px
}
.think-item li{
  padding:10px 0;
  text-align:center
}
.think-item li:hover
{
  color:#4B9AFB;
 box-shadow:0px 1px 10px 0px rgba(0,0,0,0.10);
  cursor: pointer;
  background: #fff;
}
.think-item li.selected{
    box-shadow:0px 1px 10px 0px rgba(0,0,0,0.10);
  /* background: #e4f0fe; */
}
.el-popper .popper__arrow{
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/Think/index.vue